<script setup>
import { computed } from 'vue';

// Props.
const props = defineProps({
  images: {
    type: [Array, Object],
    required: true,
  },
});

// Computed.
const imagesSorted = computed(() => {
  // ensures that images have the right order
  // (order of items in an object can vary)
  // @todo is there a way to clean this up maybe? when more time.
  const imagesArray = Object.values(props.images);
  // remove the default image object from the array
  const defaultImg = imagesArray.splice(
    imagesArray.findIndex((img) => img.alt),
    1,
  );

  imagesArray.sort((a, b) => {
    const aMedia = a.media ? +a.media['#markup'].replace(/[^0-9]/g, '') : 0;
    const bMedia = b.media ? +b.media['#markup'].replace(/[^0-9]/g, '') : 0;

    return bMedia - aMedia;
  });

  // bring back the default image
  return [...imagesArray, ...defaultImg];
});
</script>

<template>
  <picture class="responsive-image">
    <template v-for="(image, idx) in imagesSorted">
      <source
        v-if="image.media"
        :key="idx"
        :srcset="image.src['#markup']"
        :media="image.media['#markup']" />
      <img
        v-if="image.alt"
        :key="idx"
        :src="image.src['#markup']"
        :alt="image.alt['#markup']"
        class="responsive-image__img"
        loading="lazy" />
    </template>
  </picture>
</template>
